import React from 'react';

import { Card, CardBody, CardCoverPhoto } from '@react/react-spectrum/Card';

// const ACS_CARD_THUMBNAIL = `https://salesvelocity.experiencecloud.adobe.com/exc-content/static/media/2048x1280.c6d3911e.jpg`;

export default function ACSCard({ data }) {
  return (
    <Card allowsSelection={false}>
      <CardCoverPhoto src={getSolutionImage(data.imsOrg.name)} />
      <CardBody title={data.url} subtitle="Campaign Standard" />
    </Card>
  );
}
function getSolutionImage(name) {
  let number = (name.length % 4) + 1;

  return `https://demo-system-dashboard.s3.eu-north-1.amazonaws.com/images/analytics-${number}.jpg`;
}
